export default __webpack_public_path__ + "static/media/discord.39f97183.svg";